import {Subject} from "rxjs";
import {Envelope} from "./blockUiService";

const subject = new Subject();
export const MessageService = {
    sendMessage: (message: Envelope) => subject.next(message),
    getMessage: () => subject.asObservable()
};
